import { Injectable } from '@angular/core';
import {
  ApiFile,
  ApiItem,
  ApiJob,
  ApiProcess,
  ApiResponse,
} from 'app/models/api-response';
import { CoaSummary } from 'app/models/coa-summary';
import { ColumnSet } from 'app/models/columns';
import { ProcessStatus } from 'app/models/process-status';
import { TableData } from 'app/models/table-data';
import { map, Observable } from 'rxjs';

export class ApiResponseReader {
  constructor(public rawResponse: ApiResponse) {}

  get firstItem(): ApiItem | undefined {
    return this.rawResponse?.items?.[0];
  }

  get firstProcess(): ApiProcess | undefined {
    return this.firstItem?.processes?.[0];
  }

  get lastStep(): number | undefined {
    return this.firstProcess?.last_step;
  }

  get status(): ProcessStatus {
    return this.firstProcess?.status || ProcessStatus.NotSpecified;
  }

  get files(): ApiFile[] {
    return this.firstProcess?.files || [];
  }

  get jobs(): ApiJob[] {
    return this.firstProcess?.jobs || [];
  }

  getJobByType(type: number): ApiJob | undefined {
    const job = this.firstProcess?.jobs?.find((j: ApiJob) => j.type === type);

    if (job) {
      return job;
    }
    return undefined;
  }

  get trialBalanceId(): string | undefined {
    return this.firstItem?.id;
  }

  get id(): string | undefined {
    return this.firstItem?.id;
  }

  get outputFile(): ApiFile | undefined {
    return this.firstProcess?.output_file;
  }

  get columnSet(): ColumnSet | undefined {
    return this.firstProcess?.column_set;
  }

  get validatedDF(): TableData | undefined {
    return this.firstProcess?.column_set?.validated_df;
  }

  get createdAt(): string | undefined {
    return this.firstProcess?.created_at;
  }

  // TODO: Define type for cleansingSummary
  get cleansingSummary(): any {
    return this.firstProcess?.cleansing_summary;
  }

  get coaSummary(): CoaSummary | undefined {
    return this.firstProcess?.coa_summary;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ApiResponseService {
  prepareResponseForReading(
    responseObservable: Observable<any>
  ): Observable<ApiResponseReader> {
    return responseObservable.pipe(
      map((response: ApiResponse) => new ApiResponseReader(response))
    );
  }
}
